var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",style:({ background: _vm.routeBg })},[(
      !_vm.isMbShow &&
      _vm.$route.name != 'lx' &&
      _vm.$route.name != 'fb/gameDetail' &&
      _vm.$route.name != 'fb1' &&
      _vm.$route.name != 'fb2'
    )?_c('BasePcTopCom'):_vm._e(),(_vm.$route.name == 'sw' || _vm.$route.query.isCom == '/sw')?_c('swTop'):_vm._e(),(!_vm.pathShows && !_vm.isMbShow && _vm.$route.name != 'tieba')?_c('baiduTop'):_vm._e(),(
      _vm.pathShows &&
      _vm.$route.name != 'tieba' &&
      _vm.$route.name != 'fb/gameDetail' &&
      _vm.$route.name != 'fb1' &&
      _vm.$route.name != 'fb2' &&
      _vm.$route.name != 'lx'
    )?_c('homeTop'):_vm._e(),_c('div',[_c('router-view',{style:({ paddingTop: _vm.pathShow ? '0px' : '0px' })})],1),(
      _vm.pathShows &&
      !_vm.$route.query.isCom &&
      _vm.$route.name != 'tieba' &&
      _vm.$route.name != 'fb/gameDetail' &&
      _vm.$route.name != 'fb1' &&
      _vm.$route.name != 'fb2' &&
      _vm.$route.name != 'lx'
    )?_c('suspensionBar'):_vm._e(),(!_vm.pathShows && !_vm.isMbShow && _vm.$route.name != 'tieba')?_c('baiduBottom'):_vm._e(),((_vm.$route.name == 'tieba' || _vm.$route.query.isCom == '7') && !_vm.isMbShow)?_c('AppFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }